import clsx from 'clsx'
import { useEffect } from 'react'

import { type SingleSelectedValueFilter } from 'components/brokers/types'
import { Switch } from 'components/ui/switch'

const HasReceiptsFilter = ({
  selectValue,
  selectedValue,
}: SingleSelectedValueFilter) => {
  const handleSelect = (isSelected: boolean) => {
    selectValue(isSelected ? 'true' : 'false')
  }

  // Set the default value to 'true' when the component mounts.
  useEffect(() => {
    selectValue('true')
  }, [])

  return (
    <div
      style={{ width: '300px' }}
      className={clsx({
        'rounded-md bg-slate-50 flex items-center justify-between px-2 py-1 text-sm':
              true,
        'text-thatch-purple': selectedValue,
        'text-ds-text-secondary': !selectedValue,
      })}
    >
      <div>Has Receipts?</div>
      <div className='ml-auto flex items-center justify-between space-x-2 shrink-0 h-2'>
        <Switch checked={selectedValue === 'true'} onCheckedChange={handleSelect} />
      </div>
    </div>
  )
}

export default HasReceiptsFilter
